// Wrapper component that shows desktop or mobile version based on screen size
import PersonalTimetableDesktop from './PersonalTimetableDesktop';
import PersonalTimetableMobile from './PersonalTimetableMobile';

/**
 * PersonalTimetable Wrapper
 * 
 * Desktop version: Full desktop layout with integrated nav and sidebar
 * Mobile version: Mobile-optimized layout with bottom navigation
 */
export default function PersonalTimetable() {
  return (
    <>
      {/* Desktop version - hidden on mobile/tablet */}
      <div className="hidden lg:block">
        <PersonalTimetableDesktop />
      </div>
      
      {/* Mobile version - hidden on desktop */}
      <div className="lg:hidden">
        <PersonalTimetableMobile />
      </div>
    </>
  );
}
